import { Table } from '@tanstack/react-table';

import { PaginationType } from '../TanstackTable.types';

export interface GetPaginationDisabledParams<T = unknown> {
  paginationType: PaginationType;
  table: Table<T>;
  nextCursor?: string | null;
  prevCursor?: string | null;
}

export interface PaginationDisabled {
  nextDisabled: boolean;
  prevDisabled: boolean;
}

/**
 * Returns whether Next/Previous pagination buttons should be disabled
 * based on pagination type (offset uses table state; cursor uses cursor props).
 */
export function getPaginationDisabled<T = unknown>({
  paginationType,
  table,
  nextCursor,
  prevCursor,
}: GetPaginationDisabledParams<T>): PaginationDisabled {
  if (paginationType === 'offset') {
    return {
      nextDisabled: !table.getCanNextPage(),
      prevDisabled: !table.getCanPreviousPage(),
    };
  }
  const nextDisabled =
    typeof nextCursor === 'string'
      ? !nextCursor.length
      : nextCursor === undefined || nextCursor === null;
  const prevDisabled = prevCursor === undefined || prevCursor === null;
  return { nextDisabled, prevDisabled };
}
